import React, {useContext} from "react";
import './About.css';
import { StaticImage } from 'gatsby-plugin-image';
import Profile from '../../images/some.jpeg';
import {PortfolioContext} from '../../App';


const About = () => {
    const portfolio = useContext(PortfolioContext);
    const intro = portfolio['about']?.intro || "";
    const aboutme = portfolio['about']?.aboutme || "";
    const skills = portfolio['about']?.skills || [];
    const experiences = portfolio['about']?.experience || [];
    
    return (
        <section className="about-section" id="about">
            <h2 className="about-heading">
                <span>01. </span> 
                About me
                <hr style={{width: '150px', background: '#a8b2d1', marginLeft:'20px' }}></hr>
            </h2>
            <div className="inner"> 
                <div className="style-text">
                    <p>
                       {intro}
                    </p>
                    <p>
                       {aboutme}
                    </p>
                    <p>
                        Till today, I’ve had the privilege of working at{' '}
                        {experiences && experiences.map((company, i) => (
                            <span key={i}>
                                <a href={company.url}>{company.company}</a>
                                {i < experiences.length - 1 && ', '}
                            </span>
                        ))}. 
                        My main focus these days is building accessible, inclusive products and digital
                        experiences.
                    </p>

                    <p>Here are a few technologies I’ve been working with recently:</p>
                    <ul className="skills-list">
                        {skills && skills.map((skill, i) => <li key={i}>{skill}</li>)}
                    </ul>
                </div>
                <div className="style-picture">
                    <div className="wrapper">
                        <img
                            className="img"
                            src={Profile}
                            width={300}
                            quality={95}
                            formats={['AUTO', 'WEBP', 'AVIF']}
                            alt="Headshot"
                        />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default About;
